export const ADD_RENEWAL_PRICE = "ADD_RENEWAL_PRICE";

export const SET_RENEWAL_PRICE = "SET_RENEWAL_PRICE";
